import { Component, Input } from '@angular/core';
import { AddNotesComponent } from '../add-notes/add-notes.component';
import { MatDialog } from '@angular/material/dialog';
import { Notes } from 'src/app/model/employees';
import { id } from 'date-fns/locale';
import { DeleteItemComponent } from '../../delete-item/delete-item.component';
import { CommonService } from 'src/app/services/common/common.service';
import { AppService } from 'src/app/services/app/app.service';
import { RecruiterService } from 'src/app/services/recruiter/recruiter.service';
import { co } from '@fullcalendar/core/internal-common';

@Component({
  selector: 'app-notes',
  templateUrl: './notes.component.html',
  styleUrls: ['./notes.component.scss']
})
export class NotesComponent {
  @Input() employeeId!: string;
  searchInput!: string;
  public notesArr: Notes[] = [
  
  ]
  public selectedNote!: Notes | null;
  constructor(private dialog: MatDialog,private appService:AppService,private commonService:CommonService,private recruiterService:RecruiterService) { }

  ngOnInit(): void {
   
    this.getList()
  }
  onSelectedNotes(item: Notes) {
    this.selectedNote = item
    if(window.innerWidth < 768){
      item.selected = !item.selected;
      // Set the selected property to false for all other items
      this.notesArr.forEach((i) => {
        if (i !== item) {
          i.selected = false;
        }
      });
    }
  }
  getList(){
    let objReq={
      em_i:this.employeeId
    }
    this.notesArr=[]
    this.selectedNote=null
    this.recruiterService.getNotes(objReq).subscribe({
      next: (success: any) => {
        // this.spinner.hide();
        if (success.status == 200) {
        
          this.notesArr=success.msg;
          this.getDetailNotes(this.notesArr[0]["id"])
        
        }
      },
      error: (error: any) => {
        this.commonService.handleError(error)
      }
    })
  }
  getDetailNotes(id){
    let objReq={
      em_i:this.employeeId,
      no_id:id
    }
    this.recruiterService.getNoteDetail(objReq).subscribe({
      next: (success: any) => {
        // this.spinner.hide();
        if (success.status == 200) {
        
          // this.notesArr=success.msg
           this.selectedNote = success.msg[0];
           if(success.msg.tit && this.selectedNote){
            this.selectedNote.tit = success?.msg?.tit
           }
        }
      },
      error: (error: any) => {
        this.commonService.handleError(error)
      }
    })
  }
  onSearch(event) { }
  onAddEdit(type) {
    let objData = {}
    objData["em_i"]=this.employeeId;    
    if(type=='edit'){
     objData["tit"]= this.selectedNote?.tit
     objData["notes"]= this.selectedNote?.notes
     objData["file"]= this.selectedNote?.file
     objData["id"]= this.selectedNote?.id
    }

    const dialogRef = this.dialog.open(AddNotesComponent, {
      data: objData,
      autoFocus: false,
      width: '70%',
      minWidth: '300px',
      maxWidth: '750px',
      height: '98%',
      maxHeight: '680px',
      enterAnimationDuration: '300ms',
      exitAnimationDuration: "300ms",
      // minHeight:'200px'
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (result["data_added"] == true) {
          this.getList()
        }
      }
    });
  }
  onDeleteItem() {
    let id;
    const dialogRef = this.dialog.open(DeleteItemComponent, Object.assign({
      data: { api_type: "delete_content", content_type: "delete_notes", id: this.selectedNote?.id, em_i:this.employeeId}
    }));
    dialogRef.afterClosed().subscribe(result => {
      if (result && (result["delete_content"] == true)) {
        this.getList()
      }
    });
  }
  onDownload() { }
  onSelectNotes(item: any) {
    item.selected = !item.selected;
    // Set the selected property to false for all other items
    this.notesArr.forEach((i) => {
      if (i !== item) {
        i.selected = false;
      }
    });
    this.getDetailNotes(item.id)
  }
  onAttachment(){
    this.appService.downloadFile(this.selectedNote?.file,'notes')
  }
}